import React, { useEffect, useState } from "react";

import {
  Switch,
  SelectBox,
  RadioGroup,
  NumberBox,
  DateBox,
} from "devextreme-react";
import { isNumber } from "lodash";
import moment from "moment";

import FrequencyOccurenceGraph from "./FrequencyOccurenceGraph";
import UnitMissedGraph from "./UnitMissedGraph";
import { postUserLog } from "../../../../actions/common";

const MissReasonGraph = (props) => {
  const { siteDate, siteId, tierId, ophId, moduleName } = props;

  const [animate, setAnimate] = useState("");
  const [graphSwitch, setGraphSwitch] = useState(true);
  const [reasonLevel, setReasonLevel] = useState(0);
  const [isCascaded, setIsCascaded] = useState(true);
  const [numberOfReasons, setNumberOfReasons] = useState(15);
  const [filterDateType, setFilterDateType] = useState();
  const [relativeDaySelection, setRelativeDaySelection] = useState();
  const [filterDate, setFilterDate] = useState({
    startDate: moment().subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [filterDuration, setFilterDuration] = useState(60);
  const [dateRangeSelection, setDateRangeSelection] = useState({
    startDate: moment().subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, []);

  useEffect(() => {
    if (filterDateType === 1) {
      setFilterDate(dateRangeSelection);
    }
  }, [dateRangeSelection]);

  const handleRelativeFilterDate = (e) => {
    const selectedValue = e;
    setRelativeDaySelection(selectedValue);
    if (selectedValue === -1) {
      const startDate = moment(siteDate)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      setFilterDate({
        startDate,
        endDate: moment(siteDate).format("YYYY-MM-DD"),
      });
    } else if (selectedValue === 0) {
      const startDate = moment(siteDate).format("YYYY-MM-DD");
      setFilterDate({
        startDate,
        endDate: startDate,
      });
    } else if (selectedValue === 1) {
      const startDate = moment(siteDate)
        .subtract(filterDuration, "days")
        .format("YYYY-MM-DD");
      setFilterDate({
        startDate,
        endDate: moment(siteDate).format("YYYY-MM-DD"),
      });
    }

    let dayTxt = "Yesterday";
    if (selectedValue == 0) dayTxt = "Today";
    if (selectedValue == 1) {
      dayTxt = "Last " + filterDuration + " days";
    }

    postUserLog({
      event: "Pareto",
      data: {
        action: "Pareto filtered for " + dayTxt,
        module: "Digital Tier",
        section: moduleName,
        siteUId: siteId,
        widget: "OPH TRACKER",
        tierId,
      },
    });
  };

  return (
    <div className="site-view tier-wrap admin-console-wrapper">
      <div className={"site-list " + animate}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "end",
            }}
          >
            <RadioGroup
              items={[
                { label: 0, value: "Relative Date" },
                { label: 1, value: "Date Range" },
              ]}
              value={filterDateType}
              valueExpr="label"
              displayExpr="value"
              layout="horizontal"
              onValueChanged={(e) => {
                setFilterDateType(e.value);
                postUserLog({
                  event: "Pareto",
                  data: {
                    action:
                      e.value == 0
                        ? "Relative Date Selected for Pareto"
                        : "Date Range Selected for Pareto",
                    module: "Digital Tier",
                    section: moduleName,
                    siteUId: siteId,
                    widget: "OPH TRACKER",
                    tierId,
                  },
                });
              }}
            />

            {isNumber(filterDateType) && (
              <span
                style={{
                  margin: "0 8px 4px 15px",
                  fontSize: "12px",
                }}
              >
                Filter By :
              </span>
            )}

            {filterDateType === 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "end",
                }}
              >
                <div>
                  <RadioGroup
                    items={[
                      { value: -1, label: "Yesterday" },
                      { value: 0, label: "Today" },
                      { value: 1, label: "Last" },
                    ]}
                    value={relativeDaySelection}
                    valueExpr="value"
                    displayExpr="label"
                    onValueChanged={(e) => handleRelativeFilterDate(e.value)}
                    layout="horizontal"
                  />
                </div>
                <div
                  style={{
                    marginLeft: "10px",
                  }}
                >
                  <NumberBox
                    min={1}
                    width={80}
                    showSpinButtons={true}
                    value={filterDuration}
                    onValueChanged={(e) => {
                      {
                        setFilterDuration(e.value);
                        // Set Date along according to the days
                        const startDate = moment(siteDate)
                          .subtract(e.value, "days")
                          .format("YYYY-MM-DD");
                        setFilterDate({
                          startDate,
                          endDate: moment(siteDate).format("YYYY-MM-DD"),
                        });
                        postUserLog({
                          event: "Pareto",
                          data: {
                            action:
                              "Pareto filtered for Last " + e.value + " days",
                            module: "Digital Tier",
                            section: moduleName,
                            siteUId: siteId,
                            widget: "OPH TRACKER",
                            tierId,
                          },
                        });
                      }
                    }}
                  />
                </div>
              </div>
            )}

            {filterDateType === 1 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "5px",
                }}
              >
                <div>
                  <span
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    Start date
                  </span>
                  <DateBox
                    value={dateRangeSelection.startDate}
                    onValueChanged={(e) => {
                      setDateRangeSelection((prev) => {
                        return {
                          ...prev,
                          startDate: moment(e.value).format("YYYY-MM-DD"),
                        };
                      });

                      postUserLog({
                        event: "Pareto",
                        data: {
                          action:
                            "Pareto filtered for " +
                            moment(e.value).format("DD/MM/YYYY") +
                            " - " +
                            moment(dateRangeSelection.endDate).format(
                              "DD/MM/YYYY"
                            ),
                          module: "Digital Tier",
                          section: moduleName,
                          siteUId: siteId,
                          widget: "OPH TRACKER",
                          tierId,
                        },
                      });
                    }}
                    useMaskBehavior={true}
                    type="date"
                  />
                </div>
                <div>
                  <span
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    End date
                  </span>
                  <DateBox
                    value={dateRangeSelection.endDate}
                    onValueChanged={(e) => {
                      setDateRangeSelection((prev) => {
                        return {
                          ...prev,
                          endDate: moment(e.value).format("YYYY-MM-DD"),
                        };
                      });
                      postUserLog({
                        event: "Pareto",
                        data: {
                          action:
                            "Pareto filtered for " +
                            moment(dateRangeSelection.startDate).format(
                              "DD/MM/YYYY"
                            ) +
                            " - " +
                            moment(e.value).format("DD/MM/YYYY"),
                          module: "Digital Tier",
                          section: moduleName,
                          siteUId: siteId,
                          widget: "OPH TRACKER",
                          tierId,
                        },
                      });
                    }}
                    type="date"
                    useMaskBehavior={true}
                  />
                </div>
              </div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            {/* All other filters on right side */}
            <div
              style={{
                marginRight: "15px",
              }}
            >
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                Number of Reasons
              </span>
              <NumberBox
                min={1}
                width={150}
                step={5}
                showSpinButtons={true}
                value={numberOfReasons}
                onValueChanged={(e) => {
                  {
                    if (e.value > 0) {
                      setNumberOfReasons(e.value);
                    }
                  }
                }}
              />
            </div>

            <div>
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                Select Level
              </span>
              <SelectBox
                dataSource={[
                  {
                    label: "Level 0",
                    value: 0,
                  },
                  {
                    label: "Level 1",
                    value: 1,
                  },
                  {
                    label: "Level 2",
                    value: 2,
                  },
                ]}
                displayExpr="label"
                valueExpr="value"
                wrapItemText={true}
                onValueChanged={(e) => {
                  setReasonLevel(e.value);
                }}
                width={150}
                value={reasonLevel}
              />
            </div>

            <div
              style={{
                margin: "0 10px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
              }}
            >
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                Level Drilldown
              </span>
              <RadioGroup
                hint="Level Drilldown"
                items={[
                  { value: true, label: "Yes" },
                  { value: false, label: "No" },
                ]}
                valueExpr="value"
                displayExpr="label"
                onValueChanged={(e) => {
                  setIsCascaded(e.value);
                }}
                layout="horizontal"
                value={isCascaded}
              />
            </div>

            <div 
              className="rail-switch"
              style={{
                marginLeft: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                justifyContent: "flex-end",
              }}
            >
              <Switch
                value={graphSwitch}
                switchedOnText="Freq Of Occur."
                switchedOffText="Missed Qty"
                width="110px"
                defaultValue={graphSwitch}
                onValueChanged={() => setGraphSwitch(!graphSwitch)}
              />
            </div>
          </div>
        </div>

        <div
          style={{
            margin: "6px 0px",
          }}
        >
          {graphSwitch ? (
            <FrequencyOccurenceGraph
              tierId={tierId}
              startDate={filterDate.startDate}
              endDate={filterDate.endDate}
              rowcount={numberOfReasons}
              reasonLevel={reasonLevel}
              isCascaded={isCascaded}
            />
          ) : (
            <UnitMissedGraph
              tierId={tierId}
              startDate={filterDate.startDate}
              endDate={filterDate.endDate}
              rowcount={numberOfReasons}
              reasonLevel={reasonLevel}
              isCascaded={isCascaded}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(MissReasonGraph);
